import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type QualityControlRule from "./QualityControlRule";
import type QualityControlTrigger from "./QualityControlTrigger";
import type User from "./User";

@Model()
class ContentVersion extends ApplicationRecord {
  static jsonapiType = "content_versions";

  @Attr({ persist: false }) createdAt: string;

  @Attr() event: string;

  @Attr() feature: string;

  @BelongsTo() item: QualityControlRule | QualityControlTrigger;

  @Attr() itemId: number;

  @Attr() itemType: string;

  @Attr() object: Record<string, any>;

  @Attr() objectChanges: Record<string, any>;

  @BelongsTo() user: User;
}

export default ContentVersion;
